<script>
  import { layoutMethods} from "@/state/helpers";
  import raffleIdentifierView from "@/views/pages/rafflePromo/raffleIdentifier.vue";
  import prizesView from "@/views/pages/rafflePromo/prizes.vue";
  import entriesView from "@/views/pages/rafflePromo/entries.vue";
  import drawsView from "@/views/pages/rafflePromo/draws.vue";

  /**
   * Raffle Promo component
   */
  export default {
    page: {
      title: "Raffle Promo"
    },
    components: {
      raffleIdentifierView,
      prizesView,
      entriesView,
      drawsView
    },
    computed: {
    },
    data() {
      return {
        title: "Smart Raffle Promo",
        currentView:"raffleIdentifierView"
      };
    },
    methods: {
      ...layoutMethods,
      changeCurrentView(view){
        this.currentView = view;
      }
    },
    async mounted(){
      this.changeTitle({title: this.title});
      this.changeBreadCrumb({
        breadCrumbs: [
          { text: 'Peddlr', to: { name: 'Home'} },
          { text: 'Raffle Promo', to: { name: 'Raffle Promo'} }
        ]
      });
      this.changeCurrentView('raffleIdentifierView');
    }
  }
    
</script>


<template>
  <div><!-- outer div-->
    <div class="card">
      <div class="card-body p-0">
        <b-tabs content-class="p-3 text-muted">
          <b-tab @click="changeCurrentView('raffleIdentifierView')" active class="border-0">
            <template v-slot:title>
              <span class="d-none d-sm-inline-block"><i class="bx bx-trophy"></i> Raffle Identifier</span>
            </template>
            <!-- <raffle-identifier-view/> -->
          </b-tab>
          <b-tab @click="changeCurrentView('prizesView')">
            <template v-slot:title>
              <span class="d-none d-sm-inline-block"><i class="bx bx-trophy"></i> Prizes</span>
            </template>
            <!-- <prizes-view/> -->
          </b-tab>
          <b-tab @click="changeCurrentView('entriesView')">
            <template v-slot:title>
              <span class="d-none d-sm-inline-block"><i class="mdi mdi-ticket-confirmation-outline"></i> Entries</span>
            </template>
            <!-- <entries-view/> -->
          </b-tab>
          <b-tab @click="changeCurrentView('drawsView')">
            <template v-slot:title>
              <span class="d-none d-sm-inline-block"><i class="mdi mdi-medal-outline"></i> Draws</span>
            </template>
            <!-- <draws-view/> -->
          </b-tab>
          
        </b-tabs>
        <div class="px-4 pb-4">
          <component v-bind:is="currentView"></component>
        </div>
      </div>
    </div>
  </div> <!-- end of outer div-->
</template>


<style>
.card {
    border-radius: 8px;
}

.nav-tabs .nav-link.active, .nav-tabs .nav-item.show .nav-link {
    background-color: #7F4697;
    color: #fff;
    border-color: #e2e5e8 #e2e5e8 #fff;
    border-radius: 8px 8px 0 0;
}
</style>